"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _VideoLayerComponent = _interopRequireDefault(require("./VideoLayerComponent"));

var _utils = require("../../../../../configuration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SupportMaterialsComponent = function SupportMaterialsComponent(_ref) {
  var currentTab = _ref.currentTab,
      tabName = _ref.tabName;
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var marketingMaterials = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.marketingMaterials;
  });
  var additionalInformation = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.additionalInformation;
  });
  var product = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var currentLang = document.querySelector('html').getAttribute('lang');

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      iframeUrl = _useState2[0],
      setIframeUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      sortedMaterials = _useState4[0],
      setsortedMaterials = _useState4[1];

  var openVideoLayer = function openVideoLayer(url) {
    setIframeUrl(url);
  };

  var findDocumentType = function findDocumentType(url) {
    var documentIcon;
    Object.keys(dictionary.icons).map(function (icon) {
      if (url.indexOf(icon.toLowerCase()) > -1) {
        documentIcon = icon;
      }
    });
    return dictionary.icons[documentIcon];
  };

  var sortDocumentByTypes = function sortDocumentByTypes(materials) {
    var materialsObject = {};
    materials.map(function (item) {
      var materialType = item.marketingMaterialType;

      if (item.languages) {
        item.filename = item.filename.replace('.pdf', '');

        if (!materialsObject[materialType]) {
          materialsObject[materialType] = [];
        }

        materialsObject[materialType].push(item);
      }
    });
    return materialsObject;
  };

  (0, _react.useEffect)(function () {
    var allMaterials = [];
    Object.keys(additionalInformation).map(function (key) {
      return allMaterials = allMaterials.concat(additionalInformation[key]);
    });
    allMaterials = allMaterials.concat(marketingMaterials);
    setsortedMaterials(sortDocumentByTypes(allMaterials));
  }, [product]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: currentTab === tabName ? "tab__content__section active support" : "tab__content__section support",
    "data-content": tabName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content__section__row"
  }, sortedMaterials && Object.keys(sortedMaterials).map(function (key, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab__content__section__row__container",
      key: index + 14
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "tab__content__section__row__container__type"
    }, key), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "tab__content__section__row__container__support-resources"
    }, sortedMaterials[key].map(function (document, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: index,
        onClick: function onClick() {
          return document.type === 'video' ? openVideoLayer((document === null || document === void 0 ? void 0 : document.cdnUrl) || '') : null;
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: (document === null || document === void 0 ? void 0 : document.cdnUrl) || '#',
        target: "_blank",
        tabIndex: 5,
        onClick: function onClick() {
          (0, _utils.sendDataLayerEvent)('Tab', "Downloads > ".concat(key, " > ").concat(document.filename.replace('_Kitenet', '')));
          (0, _utils.sendGA4DataLayerEvent)('genericGAEvent', 'download', 'pdf', document.filename.replace('_Kitenet', ''), '', '');
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "doc-icon",
        dangerouslySetInnerHTML: {
          __html: '&#x' + findDocumentType(document === null || document === void 0 ? void 0 : document.cdnUrl) + ';'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "link-name"
      }, document.filename.replace('_Kitenet', ''))));
    })));
  })), /*#__PURE__*/_react["default"].createElement(_VideoLayerComponent["default"], {
    setUrl: setIframeUrl,
    url: iframeUrl
  }));
};

var _default = SupportMaterialsComponent;
exports["default"] = _default;